import _ from 'underscore';

export const debounced: any = (fun: Function) => _.debounce(fun, 250);
